<template>
    <v-card elevation="3" max-width="450px">
        <v-card-title>
            <router-link class="d-flex justify-center align-center text-decoration-none" to="/">
                <div class="text-black mt-5">
                    <img alt="logo" src="@/assets/images/logo.png" width="175"/>
                </div>
            </router-link>
        </v-card-title>
        <v-card-title class="text-warning text-h5">Account Restricted</v-card-title>
        <v-card-text>
            <p class="my-3">Your account has limited access due to restrictions on your organization. Please contact support at
                <a class="text-primary" href="mailto:support@simpligps.com">support@simpligps.com</a> for assistance.
            </p>

            <v-menu v-if="companies?.length">
                <template v-slot:activator="{ props }">
                    <v-list-item title="Switch Company" v-bind="props" variant="tonal"/>
                </template>
                <v-list>
                    <v-list-item
                        v-for="company in companies" :key="company.id"
                        :title="company.company_name"
                        @click="$emit('switchCompany',company.id)"
                    />
                </v-list>
            </v-menu>

            <div class="my-3">
                <v-btn size="small" variant="plain" @click="$emit('logout')">Logout</v-btn>
            </div>
        </v-card-text>
    </v-card>
</template>

<script setup>
const props = defineProps(['companies'])
const emits = defineEmits(['switchCompany', 'logout']);
</script>
